export default [{
  name: 'kpi.home',
  path: "/kpi",
  component: () => import("../pages/kpi/kpi-index.vue"),
  meta: {
    title: 'KPI系统'
  },
},
{
  path: "/kpi/ordercancel",
  component: resolve => require(["../pages/kpi/kpi-order-cancel.vue"], resolve),
  meta: {
    title: '扫码核销'
  },
},
{
  path: "/kpi/pay",
  component: resolve => require(["../pages/kpi/kpi-pay.vue"], resolve),
  meta: {
    title: '活动支出'
  },
},
{
  path: "/kpi/datachart",
  component: resolve => require(["../pages/kpi/kpi-data-chart.vue"], resolve),
  meta: {
    title: '活动数据分析'
  },
},
{
  path: "/kpi/examine", //导购员审核
  component: resolve => require(["../pages/kpi/kpi-examine.vue"], resolve),
  meta: {
    title: '人员审核'
  },
},
{
  path: "/kpi/bonuspool", //奖金池任务
  component: resolve => require(["../pages/kpi/kpi-bonus-pool.vue"], resolve),
  meta: {
    title: '奖金池任务'
  },
},
{
  name: 'kpi-addstage',
  path: "/kpi/addstage", //添加阶段
  component: resolve => require(["../pages/kpi/kpi-addstage.vue"], resolve),
  meta: {
    title: '添加阶段任务'
  },
},
{
  name: 'kpi-verifyLiveOrder',
  path: "/verifyLiveOrder", //核销扫码后跳转的界面(直播订单)
  component: resolve => require(["../pages/kpi/verifyLiveOrder.vue"], resolve),
  meta: {
    title: '直播订单核销'
  },
},
{
  name: 'kpi-verifyLike',
  path: "/verifyLike", //核销扫码后跳转的界面(集赞)
  component: resolve => require(["../pages/kpi/verifyLike.vue"], resolve),
  meta: {
    title: '集赞核销'
  },
},
{
  name: 'kpi-verifyCoupon',
  path: "/verifyCoupon", //核销扫码后跳转的界面(代金券)
  component: resolve => require(["../pages/kpi/verifyCoupon.vue"], resolve),
  meta: {
    title: '优惠券核销'
  },
},
{
  name: 'kpi-verifyGoShop',
  path: "/verifyGoShop", //核销扫码后跳转的界面(逛店核销)
  component: resolve => require(["../pages/kpi/verifyGoShop.vue"], resolve),
  meta: {
    title: '逛店核销'
  },
},
{
  name: 'kpi-verifySeckill',
  path: "/verifySeckill", //核销扫码后跳转的界面(秒杀订单)
  component: resolve => require(["../pages/kpi/verifySeckill.vue"], resolve),
  meta: {
    title: '秒杀订单核销'
  },
},
{
  name: 'kpi-task',
  path: "/kpi/task", //编辑阶段任务-品牌任务分配
  component: resolve => require(["../pages/kpi/kpi-task.vue"], resolve),
  meta: {
    title: '品牌任务分配'
  },
},
{
  name: 'kpi-progress',
  path: "/kpi/progress", //阶段任务执行情况 - 活动奖励金
  component: resolve => require(["../pages/kpi/kpi-progress.vue"], resolve),
  meta: {
    title: '任务进度'
  },
},
{
  name: 'kpi.brand.staff',
  path: "/kpi/brandstaff", //活动品牌及导购员参与情况 - 品牌
  component: resolve => require(["../pages/kpi/kpi-brand-staff.vue"], resolve),
  meta: {
    title: '活动品牌与员工'
  },
},
{
  name: 'kpi.punish',
  path: "/kpi/punish", //单阶段品牌惩罚任务
  component: resolve => require(["../pages/kpi/kpi-punish.vue"], resolve),
  meta: {
    title: '品牌惩罚任务'
  },
},
{
  name: 'kpi.basic.tasks',
  path: "/kpi/basictasks", //单阶段 - 设置单一品牌惩罚任务
  component: resolve => require(["../pages/kpi/kpi-basic-tasks.vue"], resolve),
  meta: {
    title: '品牌基础任务'
  },
},
{
  name: 'kpi.hand.punish',
  path: "/kpi/handpunish", //品牌手动奖惩
  component: resolve => require(["../pages/kpi/kpi-hand-punish.vue"], resolve),
  meta: {
    title: '品牌手动奖惩'
  },
},
{
  name: 'kpi.owner.query',
  path: "/kpi/ownerquery", //业主（客户）查询
  component: resolve => require(["../pages/kpi/kpi-owner-query.vue"], resolve),
  meta: {
    title: '业主查询'
  },
},
{
  name: 'kpi-managers-register',
  path: "/managersRegister", //品牌人注册
  meta: {
    title: '品牌负责人注册',
    isRegister: true
  },
  component: resolve => require(["../pages/kpi/kpi-managers-register.vue"], resolve),
},
{
  name: 'kpi-activity-register',
  path: "/activityRegister", //活动负责人注册
  meta: {
    title: '活动负责人注册',
    isRegister: true
  },
  component: resolve => require(["../pages/kpi/kpi-activity-register.vue"], resolve),
},
{
  name: 'kpi-staff-register',
  path: "/staffRegister", //导购员注册
  meta: {
    title: '导购员注册',
    isRegister: true
  },
  component: resolve => require(["../pages/kpi/kpi-staff-register.vue"], resolve),
},
{
  name: 'kpi-registering',
  path: "/registering", //审核中
  component: resolve => require(["../pages/kpi/kpi-registering.vue"], resolve),
  meta: {
    title: '审核中',
    isRegister: true

  },
},
{
  name: 'kpi.managers.recharge',
  path: "/kpi/managersrecharge", //充值管理
  component: resolve => require(["../pages/kpi/kpi-managers-recharge.vue"], resolve),
  meta: {
    title: '充值管理'
  },
},
{
  name: 'kpi.managers.pay',
  path: "/kpi/managerspay", //充值界面
  component: resolve => require(["../pages/kpi/kpi-managers-pay.vue"], resolve),
  meta: {
    title: '充值'
  },
},
{
  name: 'kpi.managers.record',
  path: "/kpi/managersrecord", //充值管理界面
  component: resolve => require(["../pages/kpi/kpi-managers-record.vue"], resolve),
  meta: {
    title: '充值记录'
  },
},
{
  name: 'kpi.achieve',
  path: "/kpi/achieve", //业绩
  component: resolve => require(["../pages/kpi/kpi-achieve.vue"], resolve),
  meta: {
    title: '业绩'
  },
},
{
  name: 'kpi.achieve.detail',
  path: "/kpi/achievedetail", //业绩
  component: resolve => require(["../pages/kpi/kpi-achieve-detail.vue"], resolve),
},
{
  name: 'kpi.achieve.detail.all',
  path: "/kpi/allachievedetail", //业绩
  component: resolve => require(["../pages/kpi/kpi-achieve-detail-all.vue"], resolve),
},
{
  name: 'kpi.achieve.preview',
  path: "/kpi/achievepreview", //预览客户
  component: resolve => require(["../pages/kpi/kpi-achieve-preview.vue"], resolve),
},
{
  name: 'kpi.achieve.preview.all',
  path: "/kpi/allachievepreview", //预览客户-活动负责人/品牌负责人
  component: resolve => require(["../pages/kpi/kpi-achieve-preview-all.vue"], resolve),
},
{
  name: 'kpi.achieve.market',
  path: "/kpi/achievemarket", //秒杀客户 / 集赞客户
  component: resolve => require(["../pages/kpi/kpi-achieve-market.vue"], resolve),
},
{
  name: 'kpi.achieve.market.all',
  path: "/kpi/allachievemarket", //秒杀客户 / 集赞客户
  component: resolve => require(["../pages/kpi/kpi-achieve-market-all.vue"], resolve),
},
{
  name: 'kpi.achieve.order',
  path: "/kpi/achieveorder", //业绩-订单
  component: resolve => require(["../pages/kpi/kpi-achieve-order.vue"], resolve),
},
{
  name: 'kpi.achieve.order.all',
  path: "/kpi/allachieveorder", //业绩-订单
  component: resolve => require(["../pages/kpi/kpi-achieve-order-all.vue"], resolve),
},
{
  name: 'kpi.rank',
  path: "/kpi/rank", //排行榜
  component: resolve => require(["../pages/kpi/kpi-rank.vue"], resolve),
  meta: {
    title: '排行'
  },
},
{
  name: 'kpi.rank.person',
  path: "/kpi/rankperson", //个人排行榜
  component: resolve => require(["../pages/kpi/kpi-rank-person.vue"], resolve),
},
{
  name: 'kpi.rank.brand',
  path: "/kpi/rankbrand", //品牌排行榜
  component: resolve => require(["../pages/kpi/kpi-rank-brand.vue"], resolve),
},
{
  name: 'kpi.rank.detail',
  path: "/kpi/rankdetail", //排行榜-明细
  component: resolve => require(["../pages/kpi/kpi-rank-detail.vue"], resolve),
},
{
  name: 'kpi.finance',
  path: "/kpi/finance", //财务
  component: resolve => require(["../pages/kpi/kpi-finance.vue"], resolve),
  meta: {
    title: '财务'
  },
},
{
  name: 'kpi.withdraw',
  path: "/kpi/withdraw", //提现
  component: resolve => require(["../pages/kpi/kpi-withdraw.vue"], resolve),
  meta: {
    title: '提现'
  },
},
{
  name: 'kpi.recharge',
  path: "/kpi/recharge", //充值
  component: resolve => require(["../pages/kpi/kpi-recharge.vue"], resolve),
  meta: {
    title: '充值'
  },
},
{
  name: 'kpi.rankWard',
  path: "/kpi/rankWard", //排行榜
  component: resolve => require(["../pages/kpi/kpi-ward.vue"], resolve),
  meta: {
    title: '排行'
  },
},
]